import React from "react";
import { useTranslation } from "react-i18next";
import {
  useAddPlanzoneMaterialResource,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Resource, resource } from "@planzone/dto";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import { MaterialResourceForm } from "./materialResourceForm";
import styles from "./styles.scss";

function PlanzoneMaterialResourceAddition({ cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, addPlanzoneMaterialResource } =
    useAddPlanzoneMaterialResource();
  const { planzone } = useRetrieveCurrentPlanzone();
  const [formData, setFormData] = React.useState<Resource>(resource);

  return (
    <Modal header={t("planzoneMaterialResourceAddition.title")} close={cancel}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          addPlanzoneMaterialResource({ planzone, resource: formData });
        }}
        className={styles.main}
      >
        <MaterialResourceForm formData={formData} edit={setFormData} />
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("planzoneMaterialResourceAddition.cancel")}
          </Button>
          <Button status={isRequestPending ? "pending" : "none"} type="submit">
            {t("planzoneMaterialResourceAddition.confirm")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { PlanzoneMaterialResourceAddition };
